import type { PageEvent } from '@noths/polaris-client-google-analytics';

export const getServerSidePageEventObject = (
  version: string,
  appVersion: string,
  pageEventCategory: string,
  requestIsFromBot: boolean = false,
): PageEvent => {
  if (!pageEventCategory) {
    return {};
  }

  const pageEventObject = {
    page: {
      bot_caching: requestIsFromBot ? 'true' : 'false',
      category: pageEventCategory,
      environment: process.env.NODE_ENV,
      react: 'true',
      app_version: appVersion,
      release_version: version,
    },
  };

  return pageEventObject;
};
